import React from 'react'
import useFormValidation from "../../components/auth/useFormValidation";
import validateCreateCurso from "../../components/auth/validateCreateCurso";
import FirebaseContext from "../../firebase/context";

const CompCursoListEdit = ({ props, curso, setShowCursoFormEdit, setUpdateCursoList, index }) => {
    const INITIAL_STATE = {
        tituloCurso: curso.tituloCurso,
        
        
    };

    const { firebase, user } = React.useContext(FirebaseContext);
    const { handleSubmit, handleChange, values, errors } = useFormValidation(
        INITIAL_STATE,
        validateCreateCurso,
        handleCreateCurso
    );
    let idCurso = curso.id

    function handleCreateCurso() {
        if (!user) {
            props.history.push("/login");
        } else {
            const { tituloCurso } = values;
            const editCurso = {
                tituloCurso,
 
            };

            firebase.db.collection("colCursos").doc(idCurso).set(editCurso, {merge: true});
            setShowCursoFormEdit(false);
            setUpdateCursoList(index)           
        }
    }

    return (
        <div>
            <form onSubmit={handleSubmit} >
                <label htmlFor="inputTitulo">Nombre de Curso</label>
                <input
                    onChange={handleChange}
                    value= {values.tituloCurso}
                    name="tituloCurso"
                    placeholder="Titulo de Curso"
                    autoComplete="off"
                    type="text"
                    className={errors.tituloCurso && "error-input"}
                />
                {errors.tituloCurso && <p className="error-text">{errors.tituloCurso}</p>}
                <button className="button" type="submit">
                    Actualizar
                </button>
                <button type="button" onClick={() => setShowCursoFormEdit(false)}>Cancelar</button>
            </form>
        </div>
    );
}

export default CompCursoListEdit
